"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Mail, MapPin, MessageSquare, Calendar } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const contactDetails = [{
  icon: Mail,
  title: "Direct Inquiry",
  content: "recouptime@gmail.com",
  isLink: false,
  description: "For partnership and general inquiries."
}, {
  icon: MapPin,
  title: "Headquarters",
  content: "Downtown Salem, Oregon",
  isLink: true,
  href: "#",
  description: "The heart of our AI operations."
}];
export default function ContactForm() {
  return <section data-section-id="233232" id="contact-form" className="py-24 md:py-40 bg-background text-foreground relative overflow-hidden">
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-primary/5 rounded-lg blur-[140px] -z-10" />
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-primary/5 rounded-lg blur-[140px] -z-10" />

      <div className="container mx-auto px-6 max-w-4xl">
        <div className="flex flex-col items-center text-center gap-16">
          
          <div className="space-y-8 flex flex-col items-center">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-md bg-primary/5 border border-primary/20 text-primary text-[10px] font-mono uppercase tracking-[0.2em]">
              <MessageSquare className="size-3" />
              Get in Touch
            </div>
            <h2 className="text-5xl md:text-7xl font-default font-bold tracking-tighter leading-[0.95]">
              Let's Find Your <br />
              <span className="text-primary">Hidden Hours.</span>
            </h2>
            <p className="text-muted-foreground font-sans text-xl leading-relaxed max-w-md mx-auto">
              Ready to reclaim your time? Schedule your assessment briefing directly with our team.
            </p>
          </div>

          <div className="w-full max-w-2xl">
            <div className="bg-card/30 backdrop-blur-xl p-8 md:p-16 rounded-xl border border-border/40 shadow-2xl relative overflow-hidden">
              <div className="absolute -top-10 -right-10 w-40 h-40 bg-primary/10 rounded-lg blur-3xl -z-10" />
              
              <div className="flex flex-col items-center gap-8">
                <div className="size-16 rounded-lg bg-primary/10 flex items-center justify-center text-primary border border-primary/20">
                  <SafeHydrate><Calendar className="size-8" /></SafeHydrate>
                </div>
                <div className="space-y-4">
                  <h3 className="text-2xl font-default font-bold text-foreground tracking-tight">Book Your Assessment</h3>
                  <p className="text-muted-foreground font-sans max-w-xs mx-auto">
                    Select a time for your 15-minute discovery call to begin your AI transition.
                  </p>
                </div>
                <Link to="https://tidycal.com/recouptime" newTab className="w-full">
                  <Button size="lg" className="w-full py-8 bg-primary hover:bg-primary/90 text-white font-default font-bold rounded-md transition-all shadow-lg shadow-primary/10 group">
                    Book Your Free 15-Min Call
                  </Button>
                </Link>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 w-full max-w-2xl">
            {contactDetails.map((item, index) => <div key={index} data-index={index} className="flex flex-col items-center text-center gap-4 group">
                <div className="shrink-0 p-3.5 rounded-lg bg-card border border-border/40 group-hover:border-primary/40 transition-all duration-300 shadow-sm">
                  <item.icon className="size-5 text-primary" strokeWidth={1.5} />
                </div>
                <div className="space-y-1.5">
                  <h3 className="text-[10px] font-mono uppercase tracking-[0.2em] text-muted-foreground/50">
                    {item.title}
                  </h3>
                  {item.isLink ? <Link to={item.href || "#"} className="text-xl font-default font-semibold text-foreground hover:text-primary transition-colors block">
                      {item.content}
                    </Link> : <p className="text-xl font-default font-semibold text-foreground">
                      {item.content}
                    </p>}
                  <p className="text-sm text-muted-foreground/70 font-sans leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}